import http from '@/api/http'
/**
 * 授权接口加前缀：authSystem，
 * 用户接口加前缀：userSystem,
 * 认证接口加前缀：verifySystem,
 * 日志接口加前缀：logSystem,
 */
export default {

    //登录
    login(cb, form) {
        http.post('/api/authSystem/auth/login', cb, form)
    },
    //查询用户信息
    getInfoDetail(cb, form) {
        http.get('/api/userSystem/user/space/searchUserDetail', cb, form)
    },
}